import {Link} from 'react-router-dom';
import {ReactNode} from 'react';
import {useSettings} from '../../../core/settings/use-settings';
import {Trans} from '../../../i18n/trans';
import loginIllustration from './login-illustration.png';

interface Props {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function LoginVisualLayout({heading, children, message}: Props) {
  const {branding} = useSettings();

  return (
    <main className="flex min-h-screen items-center justify-center overflow-y-auto bg-[#F4F8FB] px-20 py-40 sm:px-32">
      <div className="flex min-h-[638px] w-full max-w-[1100px] overflow-hidden rounded-[20px] bg-white shadow-[0_25px_45px_rgba(35,37,67,0.16)]">
        <div className="hidden w-[46%] flex-shrink-0 flex-col items-center justify-center bg-[#F8F9FD] px-50 py-60 text-center md:flex">
          <h2 className="mx-auto mb-20 max-w-[360px] text-[28px] font-extrabold leading-[1.25] text-[#06264B]">
            <Trans message="Awesome Page Builder Creating Stunning Websites" />
          </h2>
          <img
            src={loginIllustration}
            alt=""
            className="w-full max-w-[340px]"
          />
        </div>

        <div className="flex w-full flex-col justify-center px-24 py-40 sm:px-50 md:w-[54%] md:px-50 lg:px-50">
          <Link
            to="/"
            className="mb-22 block w-fit flex-shrink-0"
            aria-label="Homepage"
          >
            <img
              src={branding.logo_dark}
              className="block h-auto max-h-64 w-auto max-w-[240px]"
              alt=""
            />
          </Link>
          {heading && (
            <h1 className="mb-6 text-[28px] font-extrabold leading-tight text-[#06264B]">
              {heading}
            </h1>
          )}
          <p className="mb-40 max-w-[500px] text-sm leading-[1.45] text-[#7D809D]">
            <Trans message="To Keep Connected with us please login with your personal Information by email and password.." />
          </p>
          {children}
          {message && (
            <div className="mt-24 text-sm text-[#292929]">{message}</div>
          )}
        </div>
      </div>
    </main>
  );
}
